// @ts-check
import { defineStore } from "pinia";
import { useRoute } from "vue-router";
import { useClientSettingsKey } from "@/plugins/useClientSettings";
import type { SupportedLanguage } from "@/data/api-layer/clientSettingsApi";
import StudiesAPI, { type SupportedLanguageStudy } from "@/data/api-layer/studiesApi";
import { useI18n } from "@/vue-i18n/vue-i18n";

const useLocaleStore = defineStore("localeStore", () => {
   const clientSettings = inject(useClientSettingsKey);
   const $route = useRoute();
   const i18n = useI18n();

   // Site locales
   const siteSupportedLocales = clientSettings.supportedLocales;

   // Study locales
   const studyLocalesResp = ref<SupportedLanguageStudy[]>([]); // list of locales available for current study

   // Locales list in the navigation
   const pageSupportedLocales = computed<SupportedLanguageStudy[] | SupportedLanguage[]>(() => {
      if ($route.name === "study") {
         return studyLocalesResp.value;
      } else {
         return siteSupportedLocales;
      }
   });

   const currentLocale = computed(() => {
      const vueI18nValue = i18n.locale.value;
      return pageSupportedLocales.value.length && pageSupportedLocales.value.find(({ id }) => id === vueI18nValue);
   });

   // Methods
   // returns locale object for given key
   async function setStudyLocales(studyKey: string) {
      try {
         studyLocalesResp.value = await StudiesAPI.getLocales(studyKey);
      } catch (error) {
         console.error("Error getting study locales:", error);
         throw error;
      }
   }

   return { currentLocale, pageSupportedLocales, setStudyLocales, siteSupportedLocales };
});

export { useLocaleStore };
